// extracted by mini-css-extract-plugin
export default {"StudentDetailsScreen":"Messages_StudentDetailsScreen__YQSWT","container":"Messages_container__14ptL","row":"Messages_row__rGuiZ"};